import {SelectionModel} from '@angular/cdk/collections';
import {Component, Input, OnInit} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {MyValidator, PREDEFINED_VALIDATORS} from "../model/dictionary";
import {FormComponent} from "../model/form-component";
import {getKeys, getValidatorByKey, hasValidators, initValidators, setValidator} from "../model/form-component-utils";

@Component({
    selector: 'predefined-validators',
    templateUrl: 'predefined.validators.component.html',
    styleUrls: ['predefined.validators.component.scss'],
})
export class PredefinedValidatorsComponent implements OnInit {

    displayedColumns: string[] = ['select', 'name', 'message', 'value'];
    matDatasource = new MatTableDataSource<MyValidator>();
    validValidators: MyValidator[] = [];
    selection = new SelectionModel<MyValidator>(true, []);
    isReadOnly: boolean = false;
    isChanged: boolean = false;

    @Input() public formComponent: FormComponent;

    ngOnInit(): void {
        PREDEFINED_VALIDATORS.forEach(predefinedValidator => {
                if (this.isComponentTypeKeyValidForThisPredefinedValidator(predefinedValidator, this.formComponent.type)) {
                    this.validValidators.push(predefinedValidator);
                }
        });

        this.matDatasource.data = this.validValidators;

        // mark Validator Used on the validValidators list
        if (hasValidators(this.formComponent)) {
            console.log('found validators:' + this.formComponent.validators);
            console.log(typeof this.formComponent.validators);
            //const map = new Map(Object.entries(this.formComponent.validators));
            getKeys(this.formComponent.validators).forEach(key => {
                const value = getValidatorByKey(this.formComponent, key, undefined);
                console.log('found a validator:' + key);
                console.log('found a validator:' + value);
                const validator = new MyValidator();
                validator.key = key;
                validator.value = value;
                this.markValidatorUsed(validator);
            });
        }
    }

    isComponentTypeKeyValidForThisPredefinedValidator(predefinedValidator: MyValidator, componentTypeKey: string): boolean {
        return predefinedValidator.componentTypes==='' ||
            predefinedValidator.componentTypes==='*' ||
            predefinedValidator.componentTypes.indexOf(componentTypeKey) >= 0;
    }

    /**
     * Mark Validator used or already checked.
     *
     * @param validatorDto
     */
    markValidatorUsed(validatorDto: MyValidator): void {
        this.validValidators.forEach(validator => {
            if (validator.key === validatorDto.key) {
                console.log('Found one by validator Key=' + validator.key);
                this.selection.toggle(validator);
            }
        });
    }

    isNotEditable(element: MyValidator) {
        return !this.selection.isSelected(element) || this.isReadOnly;
    }

    isNumberType(value: any): boolean {
        return value !== null && value !== undefined && Number.isInteger(Number.parseInt(value));
    }

    isStringType(value: any): boolean {
        return value === '*' || value === '';
    }

    isBooleanType(value: any): boolean {
        return value !== null && value !== undefined && ((<string>value).toLowerCase() === 'true' || (<string>value).toLowerCase() === 'false');
    }

    changed(element: MyValidator, key: string, keyValue: any): void {
        this.isChanged = true;
        this.updateValidators();
    }

    toggleSelection(element: MyValidator): void {
        this.isChanged = true;
        this.selection.toggle(element);
        this.updateValidators();
    }

    updateValidators(): void {
        this.formComponent.validators = [];
        console.debug('... selected validators:' + this.selection.selected.length);
        this.selection.selected.forEach(validator => {
            console.log('selected validator:' + validator.key.toString() + ' ' + validator.value);
            setValidator(this.formComponent, validator.key.toString(), validator.value);
        });
    }
}
